export const domainConfig = {
    "com.br": {
        domain: "bycoders.com.br",
        prefix: "bycoders_br",
        locale: "pt-BR",
        hreflang: "pt-BR"
    },

    pt: {
        domain: "bycoders.pt",
        prefix: "bycoders_pt",
        locale: "pt-PT",
        hreflang: "pt-PT"
    },

    us: {
        domain: "bycoders.us",
        prefix: "bycoders_us",
        locale: "en-US",
        hreflang: "en-US"
    },

    co: {
        domain: "bycoders.co",
        prefix: "bycoders_co",
        locale: "en-US",
        hreflang: "en-US"
    }
};
